module.exports = __webpack_public_path__ + "img/icon10.7cd538df.png";